import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { CheckCircle, XCircle } from 'lucide-react';
import { auth } from '../utils/api';
import Logo from '../components/Logo';

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('verifying');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (token) {
      verifyEmail(token);
    } else {
      setStatus('error');
      setMessage('No verification token provided.');
    }
  }, [searchParams]);

  const verifyEmail = async (token) => {
    try {
      const result = await auth.verifyEmail(token);
      setStatus('success');
      setMessage(result.message || 'Email verified successfully!');
    } catch (err) {
      setStatus('error');
      setMessage(err.message || 'Verification failed.');
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 px-4">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="flex justify-center mb-6"><Logo size="lg" /></div>
        <div className="bg-white py-8 px-6 shadow rounded-lg text-center">
          {status === 'verifying' && (
            <>
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-600 mx-auto mb-4"></div>
              <p>Verifying your email...</p>
            </>
          )}
          {status === 'success' && (
            <>
              <CheckCircle className="h-16 w-16 text-green-500 mx-auto mb-4" />
              <h2 className="text-xl font-bold mb-2">Email Verified!</h2>
              <p className="text-gray-600 mb-4">{message}</p>
              <Link to="/" className="bg-red-600 text-white px-6 py-2 rounded-md inline-block">Sign In</Link>
            </>
          )}
          {status === 'error' && (
            <>
              <XCircle className="h-16 w-16 text-red-500 mx-auto mb-4" />
              <h2 className="text-xl font-bold mb-2">Verification Failed</h2>
              <p className="text-gray-600 mb-4">{message}</p>
              <Link to="/" className="text-red-600 hover:text-red-700">Return to login</Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
